/* eslint-disable react/no-array-index-key */
import MainMenu from './MainMenu';
import TopBar from './TopBar';

import styles from '../../../styles/partials/header.module.css';

interface MenuItem {
    label: string;
    url: string;
    [key: string]: unknown;
}

interface HeaderProps {
    homeLink: string;
    topMenuItems: MenuItem[];
    socialMenuItems: MenuItem[];
    mainMenuItems: MenuItem[];
    menuOpened: boolean;
}

function Header({
    homeLink,
    topMenuItems,
    socialMenuItems,
    mainMenuItems,
    menuOpened,
}: HeaderProps) {
    return (
        <div id="header" className={styles.container}>
            <div className={styles.topBar}>
                <TopBar
                    logoLink={homeLink}
                    menuItems={topMenuItems}
                    socialMenuItems={socialMenuItems}
                    menuOpened={menuOpened}
                />
            </div>
            <div className={styles.mainMenu}>
                <MainMenu
                    logoLink={homeLink}
                    menuItems={mainMenuItems}
                    pagesMenuItems={topMenuItems}
                    menuOpened={menuOpened}
                />
            </div>
        </div>
    );
}

export default Header;
